import { render, staticRenderFns } from "./authenticationList.vue?vue&type=template&id=2adb8748&scoped=true&"
import script from "./authenticationList.vue?vue&type=script&lang=js&"
export * from "./authenticationList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2adb8748",
  null
  
)

export default component.exports